import { render, staticRenderFns } from "./PagePreloader.vue?vue&type=template&id=a678018e&scoped=true&"
import script from "./PagePreloader.vue?vue&type=script&lang=js&"
export * from "./PagePreloader.vue?vue&type=script&lang=js&"
import style0 from "./PagePreloader.vue?vue&type=style&index=0&id=a678018e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a678018e",
  null
  
)

export default component.exports